import React, { useEffect, useState, useRef } from "react";
import "./ShelfEditor.css";
import { App, Button, Form, Modal, Upload } from "antd";
import { useTranslation } from "react-i18next";

const ShelfPreviewDialog = ({
  visible,
  setVisible,
  data,
  origin,
  canEdit,
  isVersion2,
}) => {
  const { t } = useTranslation();

  let iframeUrl = `/layoutEditor/makro?id=${data?.id ?? 1}&origin=${origin}`;
  if (canEdit) {
    iframeUrl += `&edit=1`;
  }
  if (isVersion2) {
    iframeUrl += `&version=2`;
  }
  return (
    <Modal
      open={visible}
      onCancel={() => {
        if (canEdit) {
          Modal.confirm({
            content: t("common.saveConfirm.message"),
            onOk() {
              setVisible(false);
            },
            onCancel() {
              // console.log("Cancel");
            },
            okText: t("common.confirm"),
            cancelText: t("common.cancel"),
          });
        } else {
          setVisible(false);
        }
      }}
      className="shelf-preview-dialog"
      footer={null}
    >
      <iframe
        src={iframeUrl}
        // style={{
        //   width: "90vw",
        //   height: "90vh",
        //   border: "none",
        // }}
      />
    </Modal>
  );
};

export default ShelfPreviewDialog;
